<div class="checkbox-wrapper">
  <p translate>user.disable</p>
  <label *ngIf="!userCheck" class="switch" (click)="notify()">
    <input *ngIf="!checkType2" type="checkbox" [disabled]="disabled" [ngModel]="defaultChecked"
      (change)="patchType($event)">
    <input *ngIf="checkType2" type="checkbox" [disabled]="disabled" [ngModel]="defaultChecked"
      (change)="patchType2($event, data)">
    <span class="slider round"></span>
  </label>
  <label *ngIf="userCheck" class="switch" (click)="notify()">
    <input type="checkbox" [disabled]="disabled" [ngModel]="defaultChecked"
      (change)="checkItem($event)">  
    <span class="slider round"></span>  
  </label>
  <p translate>user.enable</p>
</div>